import React, { Fragment } from 'react';
import { Check, X } from 'lucide-react';
interface ComparisonSectionProps {
  language: 'en' | 'es';
}
export function ComparisonSection({
  language
}: ComparisonSectionProps) {
  const features = [{
    en: 'Personalized Wealth Strategy',
    es: 'Estrategia Patrimonial Personalizada',
    mainpoint: true,
    others: false
  }, {
    en: 'Direct Access to Senior Advisors',
    es: 'Acceso Directo a Asesores Senior',
    mainpoint: true,
    others: false
  }, {
    en: 'Bilingual VIP Support',
    es: 'Soporte VIP Bilingüe',
    mainpoint: true,
    others: false
  }, {
    en: 'Standard Tax Filing',
    es: 'Declaración de Impuestos Estándar',
    mainpoint: true,
    others: true
  }, {
    en: 'Basic Insurance Policies',
    es: 'Pólizas de Seguro Básicas',
    mainpoint: true,
    others: true
  }];
  return <section id="comparison" className="py-24 bg-luxury-bg relative overflow-hidden" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-26">
          <h2 className="font-sans text-sm font-bold text-gold-light tracking-[0.2em] uppercase mb-4" data-id="element-27">
            {language === 'en' ? 'The MainPoint Difference' : 'La Diferencia MainPoint'}
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-warm-white mb-6" data-id="element-28">
            {language === 'en' ? 'Why Settle for Standard?' : '¿Por qué conformarse con lo estándar?'}
          </h3>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-29">
          <div className="grid grid-cols-3 gap-0 rounded-2xl overflow-hidden border border-gold-dark/20 bg-luxury-card" data-id="element-30">
            {/* Headers */}
            <div className="p-6 sm:p-8 bg-luxury-alt border-b border-gold-dark/20 flex items-end" data-id="element-31">
              <span className="font-serif text-xl text-warm-gray" data-id="element-32">
                {language === 'en' ? 'Features' : 'Características'}
              </span>
            </div>

            <div className="p-6 sm:p-8 bg-luxury-alt border-b border-gold-dark/20 text-center flex flex-col items-center justify-end" data-id="element-33">
              <span className="font-sans text-sm text-warm-gray uppercase tracking-widest mb-2" data-id="element-34">
                {language === 'en' ? 'Traditional' : 'Tradicional'}
              </span>
              <span className="font-serif text-xl text-warm-white" data-id="element-35">
                Brokers
              </span>
            </div>

            <div className="relative p-6 sm:p-8 bg-luxury-card border-b border-gold-primary/40 text-center flex flex-col items-center justify-end overflow-hidden" data-id="element-36">
              {/* Shimmer effect background */}
              <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent,rgba(201,168,76,0.1),transparent)] bg-[length:200%_100%] animate-shimmer" data-id="element-37" />

              {/* Recommended Badge */}
              <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-gold-gradient text-luxury-bg text-[10px] sm:text-xs font-bold tracking-widest py-1 px-3 sm:px-4 rounded-full uppercase shadow-gold-glow whitespace-nowrap z-10" data-id="element-38">
                {language === 'en' ? 'Recommended' : 'Recomendado'}
              </div>

              <span className="font-serif text-2xl sm:text-3xl font-bold text-gradient-gold relative z-10 mt-4" data-id="element-39">
                MainPoint
              </span>
            </div>

            {/* Rows */}
            {features.map((feature, idx) => <Fragment key={idx} data-id="element-40">
                <div className={`p-5 sm:p-6 flex items-center border-b border-gold-dark/10 ${idx % 2 === 0 ? 'bg-luxury-card' : 'bg-luxury-alt'}`} data-id="element-41">
                  <span className="text-sm sm:text-base text-warm-white/90 font-medium" data-id="element-42">
                    {language === 'en' ? feature.en : feature.es}
                  </span>
                </div>

                <div className={`p-5 sm:p-6 flex items-center justify-center border-b border-gold-dark/10 ${idx % 2 === 0 ? 'bg-luxury-card' : 'bg-luxury-alt'}`} data-id="element-43">
                  {feature.others ? <Check className="w-5 h-5 text-warm-gray" data-id="element-44" /> : <X className="w-5 h-5 text-warm-gray/30" data-id="element-45" />}
                </div>

                <div className={`relative p-5 sm:p-6 flex items-center justify-center border-b border-gold-primary/20 ${idx % 2 === 0 ? 'bg-luxury-card' : 'bg-luxury-alt'}`} data-id="element-46">
                  {/* Subtle side borders for the MainPoint column */}
                  <div className="absolute inset-y-0 left-0 w-px bg-gold-primary/20" data-id="element-47" />
                  <div className="absolute inset-y-0 right-0 w-px bg-gold-primary/20" data-id="element-48" />

                  {feature.mainpoint ? <div className="w-8 h-8 rounded-full bg-gold-primary/10 flex items-center justify-center border border-gold-primary/30 shadow-[0_0_10px_rgba(201,168,76,0.2)]" data-id="element-49">
                      <Check className="w-5 h-5 text-gold-light" data-id="element-50" />
                    </div> : <X className="w-5 h-5 text-warm-gray/30" data-id="element-51" />}
                </div>
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}